import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralise',
  standalone: false,
})
export class PluralisePipe implements PipeTransform {
  transform(value: string, count: number, withoutCount: boolean = false): string {
    count = parseInt(count as any as string);
    if (!value || count === 1) return withoutCount ? value : count + ' ' + value;

    if (value === 'Not Applicable' || value === 'N/A') {
      return withoutCount ? value : count + ' ' + value;
    }

    if (/[^aeiou]y$/i.test(value)) {
      return withoutCount ? value.replace(/y$/i, 'ies') : count + ' ' + value.replace(/y$/i, 'ies');
    }

    if (/(s|sh|ch|x|z)$/i.test(value)) {
      return withoutCount ? value + 'es' : count + ' ' + value + 'es';
    }

    return withoutCount ? value + 's' : count + ' ' + value + 's';
  }
}
